var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 32.2745C25.3366 32.2745 32.5 25.1111 32.5 16.2745C32.5 7.43798 25.3366 0.274536 16.5 0.274536C7.66344 0.274536 0.5 7.43798 0.5 16.2745C0.5 25.1111 7.66344 32.2745 16.5 32.2745Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.15875 16.1358L17.9333 11.6965C18.9969 11.2341 22.6038 9.75429 22.6038 9.75429C22.6038 9.75429 24.2686 9.10689 24.1298 10.6791C24.0836 11.3265 23.7137 13.5924 23.3437 16.0433L22.1877 23.3034C22.1877 23.3034 22.0952 24.367 21.309 24.552C20.5229 24.737 19.2281 23.9046 18.9969 23.7196C18.8119 23.5809 15.5287 21.5 14.3264 20.4826C14.0027 20.2052 13.6327 19.6502 14.3726 19.0028C16.0374 17.4768 18.0258 15.5809 19.2281 14.3786C19.783 13.8237 20.3379 12.5289 18.0258 14.1011L11.5056 18.4942C11.5056 18.4942 10.7657 18.9566 9.3784 18.5404C7.99112 18.1242 6.37262 17.5693 6.37262 17.5693C6.37262 17.5693 5.2628 16.8757 7.15875 16.1358Z",
    fill: "#0D151F"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.1d8c624b8165c470bb48be83b81a1494.svg";
export { ForwardRef as ReactComponent };